import {
  FETCH_COMMUNICATIONS_SUCCESS,
} from './types';

const initialState = {
  communications: [],
};

function communicationsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        communications: action.communications,
      };
    default:
      return state;
  }
}

export default communicationsReducer;
